import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/productos/getProductosActive.php';

export default function getProductosActive({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}